export default __webpack_public_path__ + "static/media/zomato-logo.04892b6a.svg";